/** Realm roles (identity contract §1): coarse roles only; business permissions come from `/api/platform/me`. */
export const realmRoles = {
  tenantUser: "tenant_user",
  tenantAdmin: "tenant_admin",
  platformOperator: "platform_operator",
} as const;

function decodeSegment(segment: string): unknown {
  const base64 = segment.replace(/-/gu, "+").replace(/_/gu, "/");
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
  const bytes = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes)) as unknown;
}

/**
 * Reads the claims of a JWT access token **without verifying it** — only to drive the UI (e.g. show the operator
 * console). The API verifies every token; nothing here is a security decision.
 */
export function readTokenClaims(token: string | null | undefined): Record<string, unknown> {
  const payload = token?.split(".")[1];
  if (!payload) return {};
  try {
    const claims = decodeSegment(payload);
    return typeof claims === "object" && claims !== null ? (claims as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}

export function realmRolesOf(claims: Record<string, unknown>): readonly string[] {
  const access = claims["realm_access"];
  if (typeof access !== "object" || access === null) return [];
  const roles = (access as Record<string, unknown>)["roles"];
  return Array.isArray(roles) ? roles.filter((role): role is string => typeof role === "string") : [];
}
